import React, { Component } from 'react'
import { kegSizes } from '../config'
import MainDrawer from '../InternalNavigation/drawer';
import InternalNavigation from '../InternalNavigation';
import { selectors, actions } from '../sagas/products/new';
import { selectors as session_selectors } from '../sagas/session'
import '../stylesheets/new_products.sass'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextInput } from '../shared/TextInput'
import S3Uploader from '../shared/ImageUpload'
import { FormError } from '../shared/FormError'
import Price from './price'
import _ from 'lodash'
import '../stylesheets/update_product.sass'

class NewProduct extends Component {
  constructor(props) {
    super(props)
    this.state = {
      drawer: false
    };
    this.submitProduct = this.props.submitProduct.bind(this)
    this.setImageUrl = this.props.setImageUrl.bind(this)
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  handleCustomSubmit = () => {
    this.submitProduct(this.props.formOne)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className={'new-product-page-wrapper'}>
          { this.props.errors && <FormError errors={this.props.errors}/> }
          <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
            <div className={'page-title'}>
              Create Product
            </div>
            <TextInput
              placeholderText={'Product Name'}
              inputName={'name'}
              label={'Product Name'}
            />
            <TextInput
              placeholderText={'This will be displayed to customers'}
              inputName={'description'}
              label={'Description'}
              textarea
              rows={3}
              extraClass={'description-text-area'}
            />
            <div className={'product-upload-card'}>
              <S3Uploader
                token={this.props.token}
                type={'product'}
                path={'product'}
                finished={this.setImageUrl}
              />
            </div>
            <input
              value="Save"
              type="submit"
              id='continue-button' />
          </form>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => ({
  token: session_selectors.token(store),
  errors: selectors.errors(store)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  { form: 'new_product'}
)(NewProduct)));



// WEBPACK FOOTER //
// ./src/Products/new.jsx